import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       onChange - function
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function RadioPicker({ value, children, onChange }) {
    return (
        <RadioGroup value={value} onChange={onChange}>
            {
                React.Children.map(children, child => {
                    // Checking isValidElement is the safe way and avoids a typescript
                    // error too.
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, { selected: value });
                    }
                    return child;
                })
            }
        </RadioGroup>
    );
}
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       selected - string
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function RadioOption({ value, children, selected, classes }) {
    return (
        <div className={value === selected ? `${classes ? classes : ""}` : `passive-element ${classes ? classes : ""}`} style={{ display: 'flex', width: '100%' }}>
            <FormControlLabel style={{ margin: 0 }} value={value} control={<Radio color="#C4C4C4" size='small' />} />
            <div style={{ width: '100%' }}>
                {children}
            </div>
        </div>
    );
}
export { RadioPicker, RadioOption };